module.exports = __webpack_public_path__ + "img/word-structure.45525103.jpg";